import SEO from "@/components/SEO";

export const Privacy = () => (
  <div className="rn3-container py-16 max-w-3xl">
    <SEO
      title="Privacy Policy — Roman Numerals III"
      description="How Roman Numerals III collects, uses, and protects your information."
      path="/privacy"
      breadcrumbs={[{ name: "Home", path: "/" }, { name: "Privacy Policy", path: "/privacy" }]}
    />
    <div className="rn3-eyebrow">Legal</div>
    <h1 className="font-serif-display text-5xl mt-3">Privacy Policy</h1>
    <div className="border-t border-[#C4A252] w-12 my-6" />
    <div className="prose prose-sm max-w-none text-[#404040] leading-relaxed space-y-4">
      <p>Roman Numerals III ("we", "our") respects your privacy. This policy describes how we collect, use, and protect your information.</p>
      <h3 className="font-serif-display text-xl text-[#0A0A0A]">Information We Collect</h3>
      <p>Information you provide via intake forms, appointment requests, document uploads, and account registration (name, email, phone, address, documents).</p>
      <h3 className="font-serif-display text-xl text-[#0A0A0A]">How We Use It</h3>
      <p>To deliver our services (bookkeeping, tax preparation, notary, ITIN, sales tax, translation), schedule appointments, and communicate with you.</p>
      <h3 className="font-serif-display text-xl text-[#0A0A0A]">Sharing</h3>
      <p>We do not sell your data. We share only with authorities or partners required to complete the services you request.</p>
      <h3 className="font-serif-display text-xl text-[#0A0A0A]">Security</h3>
      <p>Documents are stored securely. Access is restricted to authorized personnel.</p>
      <p className="text-xs text-[#737373] pt-6">For questions, contact info@romannumeralsiii.com.</p>
    </div>
  </div>
);

export const Terms = () => (
  <div className="rn3-container py-16 max-w-3xl">
    <SEO
      title="Terms of Service — Roman Numerals III"
      description="Terms of service governing use of the Roman Numerals III platform."
      path="/terms"
      breadcrumbs={[{ name: "Home", path: "/" }, { name: "Terms of Service", path: "/terms" }]}
    />
    <div className="rn3-eyebrow">Legal</div>
    <h1 className="font-serif-display text-5xl mt-3">Terms of Service</h1>
    <div className="border-t border-[#C4A252] w-12 my-6" />
    <div className="prose prose-sm max-w-none text-[#404040] leading-relaxed space-y-4">
      <p>By using this platform you agree to the following terms.</p>
      <h3 className="font-serif-display text-xl text-[#0A0A0A]">Services</h3>
      <p>Roman Numerals III provides bookkeeping, tax preparation, notary services, ITIN support, sales tax reporting, and Spanish translation. Specific engagements are governed by separate engagement letters when applicable.</p>
      <h3 className="font-serif-display text-xl text-[#0A0A0A]">Client Responsibilities</h3>
      <p>You agree to provide accurate, complete information and documents necessary for the services requested.</p>
      <h3 className="font-serif-display text-xl text-[#0A0A0A]">Liability</h3>
      <p>Services are provided in good faith based on the information you supply. Limitations of liability are described in your engagement letter, when applicable.</p>
      <p className="text-xs text-[#737373] pt-6">For questions, contact info@romannumeralsiii.com.</p>
    </div>
  </div>
);
